var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-colxx",
    { staticClass: "disable-text-selection" },
    [
      _c("TopMenu", {
        attrs: { title: _vm.$t("menu.your-posts"), config: {} },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-4" },
        [
          _c("b-colxx", { attrs: { xxs: "12" } }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "b-button-group",
                      [
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.viewMode === "list" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "list"
                              },
                            },
                          },
                          [_vm._v("List")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.viewMode === "calendar" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "calendar"
                              },
                            },
                          },
                          [_vm._v("Calendar")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          variant: "outline-success",
                          size: "sm",
                          disabled: _vm.refreshing,
                        },
                        on: { click: _vm.refreshPosts },
                      },
                      [
                        !_vm.refreshing
                          ? _c("i", { staticClass: "simple-icon-refresh" })
                          : _c("b-spinner", { attrs: { small: "" } }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.refreshing ? "Refreshing..." : "Refresh"
                            ) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button-group",
                      [
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.currentFilter === "all" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("all")
                              },
                            },
                          },
                          [_vm._v("\n              All\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.currentFilter === "pending" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("pending")
                              },
                            },
                          },
                          [_vm._v("\n              Pending\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.currentFilter === "posted" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("posted")
                              },
                            },
                          },
                          [_vm._v("\n              Posted\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            class: { active: _vm.currentFilter === "engaged" },
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter("engaged")
                              },
                            },
                          },
                          [_vm._v("\n              Engaged\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoad
        ? [
            _vm.viewMode === "list"
              ? [
                  _c(
                    "div",
                    { staticClass: "mb-3 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "danger",
                            size: "sm",
                            disabled: _vm.nuking,
                          },
                          on: { click: _vm.onNuclearDelete },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.nuking
                                  ? "Deleting Scheduled..."
                                  : "Delete ALL Scheduled (⚠️)"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.postsToRender.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { key: "thumb" },
                            _vm._l(_vm.postsToRender, function (item, index) {
                              return _c("ListPost", {
                                key: index,
                                attrs: {
                                  id: item.id,
                                  cyPrefix: `list-item-post-${index}`,
                                  data: item,
                                  highlight: index === 0,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "text-center mt-4" }, [
                        _c("h5", [_vm._v("No posts found.")]),
                        _vm._v(" "),
                        _vm.currentFilter === "engaged"
                          ? _c("p", [
                              _vm._v(
                                "\n          None of your posts have any engagement.\n        "
                              ),
                            ])
                          : _c("p", [
                              _vm._v(
                                "\n          You haven't posted anything in the past 30 days.\n        "
                              ),
                            ]),
                      ]),
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mb-3 d-flex align-items-center justify-content-between",
                    },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          options: [
                            { text: "Month", value: "month" },
                            { text: "Week", value: "week" },
                          ],
                          buttons: "",
                          "button-variant": "outline-primary",
                          size: "sm",
                        },
                        model: {
                          value: _vm.calendarMode,
                          callback: function ($$v) {
                            _vm.calendarMode = $$v
                          },
                          expression: "calendarMode",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "danger",
                            size: "sm",
                            disabled: _vm.nuking,
                          },
                          on: { click: _vm.onNuclearDelete },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.nuking
                                  ? "Deleting Scheduled..."
                                  : "Delete ALL Scheduled (⚠️)"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.calendarMode === "week"
                    ? _c("PostsWeekCalendar", {
                        key: _vm.calendarKey,
                        attrs: { posts: _vm.filteredCalendarPosts },
                        on: { "post-click": _vm.openPostModal },
                        model: {
                          value: _vm.calendarSelectedDate,
                          callback: function ($$v) {
                            _vm.calendarSelectedDate = $$v
                          },
                          expression: "calendarSelectedDate",
                        },
                      })
                    : _c("PostsCalendar", {
                        key: _vm.calendarKey,
                        attrs: { posts: _vm.filteredCalendarPosts },
                        on: {
                          change: _vm.onCalendarDateChange,
                          "day-click": _vm.openDayModal,
                          "post-click": _vm.openPostModal,
                        },
                        model: {
                          value: _vm.calendarSelectedDate,
                          callback: function ($$v) {
                            _vm.calendarSelectedDate = $$v
                          },
                          expression: "calendarSelectedDate",
                        },
                      }),
                ],
          ]
        : [
            _c("div", {
              staticClass: "loading",
              attrs: { "data-cy": "div-loading" },
            }),
          ],
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            "hide-footer": "",
            title: _vm.dayModalData.date
              ? `Posts on ${_vm.dayModalData.date.toLocaleDateString()}`
              : "Posts",
          },
          model: {
            value: _vm.showDayModal,
            callback: function ($$v) {
              _vm.showDayModal = $$v
            },
            expression: "showDayModal",
          },
        },
        [
          _c(
            "b-row",
            _vm._l(_vm.dayModalData.posts, function (item, index) {
              return _c("ListPost", {
                key: "day-" + index,
                attrs: {
                  id: item.id,
                  cyPrefix: `modal-day-post-${index}`,
                  data: item,
                  highlight: false,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", "hide-footer": "", title: "Post Details" },
          model: {
            value: _vm.showPostModal,
            callback: function ($$v) {
              _vm.showPostModal = $$v
            },
            expression: "showPostModal",
          },
        },
        [
          _vm.postModalData
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c("ListPost", {
                        attrs: {
                          id: _vm.postModalData.id,
                          cyPrefix: "modal-post",
                          data: _vm.postModalData,
                          highlight: false,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.primaryPostLink(_vm.postModalData)
                    ? _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                href: _vm.primaryPostLink(_vm.postModalData),
                                target: "_blank",
                                variant: "primary",
                              },
                            },
                            [_vm._v("\n          View on Platform\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }